import { useNavigator } from '@repo/toolkit/use-navigator'
import { BuildingTwoIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createTeachingHall } from '../../../api/ols/teaching-halls/create-teaching-hall'
import UserNavBar from '../../../components/elements/nav-bar'
import TeachingHallForm from '../../../components/pages/teaching-halls/teaching-hall-form'
import { Paths } from '../../../lib/constants/path'
import useAuth from '../../../lib/hooks/use-auth'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

const TeachingHallCreatePage = () => {
  const { navigate, back } = useNavigator()
  const { user } = useAuth()

  const { mutateAsync } = useMutation({
    mutationFn: createTeachingHall,
    onSuccess: () => toast.success('Teaching hall created successfully'),
    onError: showAxiosError
  })

  const olId = user?.ol?.id

  if (!olId) return null

  return (
    <div>
      <UserNavBar title={'Add a new teaching hall'} icon={BuildingTwoIcon} />
      <div className={'h-4'} />
      <TeachingHallForm
        buttonsConfig={twoButtonsConfig({
          isEnglish: true,
          onCancel: () => back(Paths.TEACHING_HALLS_LIST_PAGE),
          onConfirm: async (values) => {
            const res = await mutateAsync({ olId, ...values })
            navigate(Paths.TEACHING_HALL_UPDATE_PAGE.replace(':id', res.id.toString()), {
              replace: true
            })
          }
        })}
      />
    </div>
  )
}

export default TeachingHallCreatePage
